import client from "../client";

export interface UpdateReadUserRequest {
  prefix: string;
  username: string;
}

export default function API(request: UpdateReadUserRequest) {
  return client
    .post(`chat/update_read_user`, request)
    .then((response) => response.data);
}
